// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressOptionalRequest } from './address-optional-request';

// @ts-ignore
import { EyefinityOrderItemRequest } from './eyefinity-order-item-request';

// @ts-ignore
import { UpdateEyefinityOrderRequest } from './update-eyefinity-order-request';

// @ts-ignore
import { UpdateEyeglassLensMeasurementsRequest } from './update-eyeglass-lens-measurements-request';

/** See com.rev360.pms.api.controller.order.eyefinity.UpdateEyefinityEyeglassOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateEyefinityEyeglassOrderRequest extends UpdateEyefinityOrderRequest {

	@GandalfLabel('AR Coating')
	@GandalfProperty({ designType: Number })
	arCoatingId!: number | null;

	@GandalfLabel('Associated Authorization')
	@GandalfValidator({ sizeString: { message: 'Associated Authorization cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	associatedAuthorization!: string | null;

	@GandalfLabel('Contact Lens Benefit')
	@GandalfProperty({ designType: Boolean })
	benefitContactLens!: boolean | null;

	@GandalfLabel('Exam Benefit')
	@GandalfProperty({ designType: Boolean })
	benefitExam!: boolean | null;

	@GandalfLabel('Frame Benefit')
	@GandalfProperty({ designType: Boolean })
	benefitFrame!: boolean | null;

	@GandalfLabel('Lens Benefit')
	@GandalfProperty({ designType: Boolean })
	benefitLens!: boolean | null;

	@GandalfLabel('Lens Bevel')
	@GandalfValidator({ sizeString: { message: 'Lens Bevel cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	bevelExternalIdentifier!: string | null;

	@GandalfValidator({ sizeString: { message: 'Comment cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfLabel('Exam Copay')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	copayExam!: number | null;

	@GandalfLabel('Materials Copay')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	copayMaterials!: number | null;

	@GandalfLabel('DPD')
	@GandalfProperty({ designType: Number })
	distancePd!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dueDate!: Date | null;

	@GandalfLabel('Lens Edge')
	@GandalfProperty({ designType: Number })
	edgeId!: number | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfLabel('Estimate Discounts')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	estimatedDiscounts!: number | null;

	@GandalfLabel('Estimated Insurance Benefit')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	estimatedInsuranceBenefit!: number | null;

	@GandalfLabel('Frame Supplier')
	@GandalfValidator({ sizeString: { message: 'Frame Supplier cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	externalFrameSupplierIdentifier!: string | null;

	@GandalfLabel('Frame Supplier Name')
	@GandalfValidator({ sizeString: { message: 'Frame Supplier Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	externalFrameSupplierName!: string | null;

	@GandalfValidator({ sizeString: { message: 'Supplier cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	externalSupplierIdentifier!: string | null;

	@GandalfValidator({ sizeString: { message: 'Supplier Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	externalSupplierName!: string | null;

	@GandalfLabel('Fee Schedule')
	@GandalfProperty({ designType: Number })
	eyefinityFeeScheduleId!: number | null;

	@GandalfLabel('Order Items')
	@GandalfArray(EyefinityOrderItemRequest)
	eyefinityOrderItems!: EyefinityOrderItemRequest[] | null;

	@GandalfLabel('Allowance')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	frameAllowance!: number | null;

	@GandalfLabel('Frame Color')
	@GandalfProperty({ designType: Number })
	frameColorId!: number | null;

	@GandalfLabel('Frame Cost')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	frameCost!: number | null;

	@GandalfLabel('Frame Product')
	@GandalfProperty({ designType: Number })
	frameId!: number | null;

	@GandalfLabel('Frame Inventory')
	@GandalfProperty({ designType: Number })
	frameItemId!: number | null;

	@GandalfLabel('Frame Remake Cost')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	frameRemakeCost!: number | null;

	@GandalfLabel('Frame Size')
	@GandalfProperty({ designType: Number })
	frameSizeId!: number | null;

	@GandalfLabel('Wholesale Allowance')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	frameWholesaleAllowance!: number | null;

	@GandalfLabel('Glass Coating')
	@GandalfProperty({ designType: Number })
	glassCoatingId!: number | null;

	@GandalfValidator({ sizeString: { message: 'Instructions cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	instructions!: string | null;

	@GandalfLabel('Is Valid')
	@GandalfProperty({ designType: Boolean })
	isValid!: boolean | null;

	@GandalfLabel('Lens Cost')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	lensCost!: number | null;

	@GandalfConstantDecorator(constants.EyefinityLensLocation)
	@GandalfLabel('Lens Eye')
	@GandalfValidator({ notNull: { message: 'Lens Eye is required' } })
	@GandalfProperty({ designType: constants.EyefinityLensLocation, isRequired: true })
	lensEye!: constants.EyefinityLensLocation;

	@GandalfLabel('Lens Material')
	@GandalfValidator({ sizeString: { message: 'Lens Material cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	lensMaterialExternalIdentifier!: string | null;

	@GandalfLabel('Lens Remake Cost')
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	lensRemakeCost!: number | null;

	@GandalfConstantDecorator(constants.OrderLensRequest)
	@GandalfLabel('Lens Request')
	@GandalfValidator({ notNull: { message: 'Lens Request is required' } })
	@GandalfProperty({ designType: constants.OrderLensRequest, isRequired: true })
	lensRequest!: constants.OrderLensRequest;

	@GandalfLabel('Lens Style')
	@GandalfProperty({ designType: Number })
	lensStyleId!: number | null;

	@GandalfLabel('Lens Type')
	@GandalfValidator({ sizeString: { message: 'Lens Type cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	lensTypeExternalIdentifier!: string | null;

	@GandalfLabel('Tint Sample %')
	@GandalfValidator({ min: { min: 0, message: '{jakarta.validation.constraints.Min.message}' } })
	@GandalfValidator({ max: { max: 100, message: '{jakarta.validation.constraints.Max.message}' } })
	@GandalfProperty({ designType: Number })
	lightDarkPercentage!: number | null;

	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfLabel('Mirror Coating')
	@GandalfProperty({ designType: Number })
	mirrorCoatingId!: number | null;

	@GandalfLabel('NPD')
	@GandalfProperty({ designType: Number })
	nearPd!: number | null;

	@GandalfLabel('Lens Nose Pads')
	@GandalfProperty({ designType: Boolean })
	nosePads!: boolean | null;

	@GandalfLabel('Lens Nose Pads Other')
	@GandalfValidator({ sizeString: { message: 'Lens Nose Pads Other cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	nosePadsOther!: string | null;

	@GandalfValidator({ sizeString: { message: 'Notification Comments cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	notificationComments!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	notificationDate!: Date | null;

	@GandalfSubRequestLabel('OD')
	@GandalfLabel('OD Measurements')
	@GandalfValidator({ notNull: { message: 'OD Measurements is required' } })
	@GandalfProperty({ designType: UpdateEyeglassLensMeasurementsRequest, isRequired: true })
	odLensMeasurements!: UpdateEyeglassLensMeasurementsRequest;

	@GandalfConstantDecorator(constants.OrderOpticalCenterType)
	@GandalfLabel('Optical Center Type')
	@GandalfProperty({ designType: constants.OrderOpticalCenterType })
	opticalCenterType!: constants.OrderOpticalCenterType | null;

	@GandalfConstantDecorator(constants.OrderFrameIndication)
	@GandalfLabel('Frame Indicator')
	@GandalfValidator({ notNull: { message: 'Frame Indicator is required' } })
	@GandalfProperty({ designType: constants.OrderFrameIndication, isRequired: true })
	orderFrameIndication!: constants.OrderFrameIndication;

	@GandalfConstantDecorator(constants.OrderFrameSource)
	@GandalfLabel('Frame Source')
	@GandalfValidator({ notNull: { message: 'Frame Source is required' } })
	@GandalfProperty({ designType: constants.OrderFrameSource, isRequired: true })
	orderFrameSource!: constants.OrderFrameSource;

	@GandalfValidator({ notNull: { message: 'Order is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	orderId!: number;

	@GandalfSubRequestLabel('OS')
	@GandalfLabel('OS Measurements')
	@GandalfValidator({ notNull: { message: 'OS Measurements is required' } })
	@GandalfProperty({ designType: UpdateEyeglassLensMeasurementsRequest, isRequired: true })
	osLensMeasurements!: UpdateEyeglassLensMeasurementsRequest;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	otherCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	otherRemakeCost!: number | null;

	@GandalfLabel('Panto')
	@GandalfProperty({ designType: Number })
	pantoscopicTilt!: number | null;

	@GandalfValidator({ notNull: { message: 'Patient Notified is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	patientNotified!: boolean;

	@GandalfLabel('Eyeglass Prescription')
	@GandalfProperty({ designType: Number })
	prescriptionId!: number | null;

	@GandalfLabel('Lens Press-on')
	@GandalfProperty({ designType: Boolean })
	pressOn!: boolean | null;

	@GandalfLabel('Lens Press-on Other')
	@GandalfValidator({ sizeString: { message: 'Lens Press-on Other cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	pressOnOther!: string | null;

	@GandalfProperty({ designType: Number })
	processorId!: number | null;

	@GandalfLabel('Quantity')
	@GandalfValidator({ notNull: { message: 'Quantity is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	quantity!: number;

	@GandalfLabel('Tint Sample')
	@GandalfValidator({ sizeString: { message: 'Tint Sample cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	sampleExternalIdentifier!: string | null;

	@GandalfLabel('Scratch Coating')
	@GandalfProperty({ designType: Number })
	scratchCoatingId!: number | null;

	@GandalfConstantDecorator(constants.OrderSegHeightType)
	@GandalfLabel('Seg Height Type')
	@GandalfProperty({ designType: constants.OrderSegHeightType })
	segHeightType!: constants.OrderSegHeightType | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	shipCost!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	shipRemakeCost!: number | null;

	@GandalfProperty({ designType: AddressOptionalRequest })
	shipToOtherAddress!: AddressOptionalRequest | null;

	@GandalfConstantDecorator(constants.OrderShipToType)
	@GandalfValidator({ notNull: { message: 'Ship To is required' } })
	@GandalfProperty({ designType: constants.OrderShipToType, isRequired: true })
	shipToType!: constants.OrderShipToType;

	@GandalfConstantDecorator(constants.OrderShipmentCompany)
	@GandalfProperty({ designType: constants.OrderShipmentCompany })
	shippingCompany!: constants.OrderShipmentCompany | null;

	@GandalfConstantDecorator(constants.OrderShippingSpeed)
	@GandalfProperty({ designType: constants.OrderShippingSpeed })
	shippingSpeed!: constants.OrderShippingSpeed | null;

	@GandalfLabel('Lens Slab Off')
	@GandalfProperty({ designType: Boolean })
	slabOff!: boolean | null;

	@GandalfLabel('Lens Slab Off Other')
	@GandalfValidator({ sizeString: { message: 'Lens Slab Off Other cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	slabOffOther!: string | null;

	@GandalfLabel('Lens Thickness')
	@GandalfValidator({ sizeString: { message: 'Lens Thickness cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	thicknessExternalIdentifier!: string | null;

	@GandalfLabel('Tint Color')
	@GandalfValidator({ sizeString: { message: 'Tint Color cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	tintColorExternalIdentifier!: string | null;

	@GandalfLabel('Tint Color Other')
	@GandalfValidator({ sizeString: { message: 'Tint Color Other cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	tintColorOther!: string | null;

	@GandalfLabel('Tint Type')
	@GandalfProperty({ designType: Number })
	tintTypeId!: number | null;

	@GandalfValidator({ sizeString: { message: 'Tracking # cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	trackingNumber!: string | null;

	@GandalfLabel('Tray')
	@GandalfValidator({ sizeString: { message: 'Tray cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	tray!: string | null;

	@GandalfLabel('UV Coating')
	@GandalfProperty({ designType: Number })
	uvCoatingId!: number | null;

	@GandalfProperty({ designType: Number })
	vendorId!: number | null;

	@GandalfValidator({ sizeString: { message: 'Vendor Order # cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	vendorOrderIdentifier!: string | null;

	@GandalfValidator({ notNull: { message: 'Version is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	version!: number;

	@GandalfLabel('Wrap')
	@GandalfProperty({ designType: Number })
	wrapAngle!: number | null;

}
